var _rect, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChannelViewEmptyState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 258,
    viewBox: "0 0 258 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 258,
    height: 258,
    rx: 129,
    fill: "#292836",
    fillOpacity: 0.06
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_32947",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 258,
    height: 258
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 129C0 0 0 0 129 0C258 0 258 0 258 129C258 200.245 200.245 258 129 258C57.7553 258 0 200.245 0 129Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_32947)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_8_32947)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 16,
    width: 183,
    height: 245,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 35,
    r: 11,
    fill: "#4F830F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 78,
    r: 11,
    fill: "#C4C4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 29,
    width: 44,
    height: 12,
    rx: 6,
    fill: "#4F830F14"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 123,
    r: 11,
    fill: "#4F830F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 157,
    r: 11,
    fill: "#C4C4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 72,
    width: 101,
    height: 12,
    rx: 6,
    fill: "#EBEAEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 88,
    width: 45,
    height: 12,
    rx: 6,
    fill: "#EBEAEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 117,
    width: 83,
    height: 12,
    rx: 6,
    fill: "#4F830F14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 151,
    width: 45,
    height: 12,
    rx: 6,
    fill: "#EBEAEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 54,
    width: 182,
    height: 1,
    fill: "#EBEAEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 29,
    width: 47,
    height: 12,
    rx: 6,
    fill: "#EBEAEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 16.5,
    width: 182,
    height: 244,
    rx: 7.5,
    stroke: "#EBEAEE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_8_32947",
    x: 17.5,
    y: 16,
    width: 223,
    height: 285,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8_32947"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8_32947"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8_32947"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8_32947",
    result: "effect2_dropShadow_8_32947"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8_32947",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelViewEmptyState);
export default __webpack_public_path__ + "static/media/channel-view-empty-state.e20ffcf1.svg";
export { ForwardRef as ReactComponent };